// extracted by mini-css-extract-plugin
export var configurationSection = "_rv-0";